module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0008.jpg?v=9ba2e226";